/* eslint-disable max-len */
import React, {
    useState,
    useEffect,
    useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonLanguage } from './ButtonLanguage';
import styled from 'styled-components';
import useOutsideClick from '../../hooks/useOutsideClick';
import { getTranslates } from '../../store/languages/languagesService';
import { breakpoints } from '../../style/size';

const ContainerProfile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 350px;
    background-color: transparent;
    border-radius: 10px;
    min-height: 40px;
    padding: 5px;
    cursor: pointer;

    &.container {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        top: 72%;
        left: 38px;
        border-radius: 10px;
        max-width: 250px;
        width: auto;
        z-index: 1;
        // position: fixed;
        min-height: 55px;
        padding: 5px;
        cursor: pointer;
        background-color: transparent;

          @media only screen and (${breakpoints.mobile}) {
                top: 9px;
                right: 15%;
                width: auto;
                justify-content: center;
                left: auto;
        }
    }

    &.containerLight {
        background-color: #EBF1FF;
    }
`

const ButtonContainer = styled.div`
    display: flex;
    width: 90%;
    align-items: center;
    // justify-content: center;
    gap: 10px;

    & > svg > path {
        fill: ${(props) => props.theme.green};
    }
`

const Span = styled.span`
    color: ${(props) => props.theme.blueish4};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    width: max-content;

    // &.spanLight {
    //     color: black;
    // }
`

const LanguageSwitcherDropDownProfile = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 190px;
    overflow-y: scroll;
    position: absolute;
    z-index: 1;

    &.languageSwitcherDropDown {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 20vh;
        overflow-y: scroll;
        overflow-x: hidden;
        background-color: ${(props) => props.theme.black};
        scrollbar-width: auto;
    }

    &.top-language-switcher {
        top: 25px;
        left: -150px;
    }
`

const Button = styled.div`
    cursor: pointer;
    border: none;
    font-weight: 700;
    font-size: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.eng {
        background-color: transparent;
        color: red;
    }
`

export const LanguageSwitcher = ({ isProfile, containerStyle = {}, menuIsOpen = true, isTop = false }) => {
    const dispatch = useDispatch()
    const { i18n } = useTranslation();
    const [openSelector, setOpenSelector] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const languages = useSelector((state) => state.lexicon.languages);
    const isLoading = useSelector((state) => state.lexicon.loagingLanguages)
    // необходима для конкатинации английского языка, так как оне не приходит с back
    const langWithEnglish = [{
        id: 0,
        name: 'English',
        short_name: 'en',
    }, ...languages]
    useEffect(() => {
        const setDefaultLanguageIfExist = () => {
            const language = localStorage.getItem('language');
            language && setSelectedLanguage(language);
        }

        setDefaultLanguageIfExist();
    }, [])
    const changeLanguage = (languageKey) => {
        i18n.changeLanguage(languageKey);
        localStorage.setItem('language', languageKey);
        setSelectedLanguage(languageKey);
        setOpenSelector(false);
        dispatch(getTranslates(languageKey) || 'en');
    };

    const dropdownRef = useRef(null)

    useOutsideClick({
        handleClick: () => setOpenSelector(false),
        ref: dropdownRef,
    })

    const text = langWithEnglish.find((item) => item.short_name === selectedLanguage);
    return (
        !isLoading && (
            <ContainerProfile
                ref={dropdownRef}
                style={containerStyle}
                className={`${!isProfile ? 'container' : ''}`}
            >
                {
                    !openSelector ? (
                        <ButtonContainer onClick={() => setOpenSelector(true)}>
                            <ButtonContainer>
                                <div style={{ display: 'flex' }}>
                                    {selectedLanguage === 'en' ? (
                                        <span
                                            role='img'
                                            className='fflag fflag-US ff-xl ff-round'
                                        />
                                    ) : (
                                        <img style={{ objectFit: 'contain' }} width={25} height={25} src={text?.flag} alt='flag' />
                                    )}
                                </div>
                                <Button className={'eng'} style={{ display: menuIsOpen ? 'flex' : 'none' }}>
                                    <Span className={`${(localStorage.getItem("theme") || 'light') === 'light' ? 'spanLight' : ''}`}>{text?.name}</Span>
                                </Button>
                            </ButtonContainer>
                            {/* <svg width='19' height='16' viewBox='0 0 19 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path d='M12.0981 14.5C10.9434 16.5 8.05662 16.5 6.90192 14.5L1.27276 4.75C0.118059 2.75 1.56143 0.25 3.87084 0.25L15.1292 0.250001C17.4386 0.250002 18.8819 2.75 17.7272 4.75L12.0981 14.5Z' fill='white' />
                            </svg> */}
                        </ButtonContainer>
                    ) : (
                        <LanguageSwitcherDropDownProfile className={`${!isProfile ? 'languageSwitcherDropDown' : ''} ${isTop ? 'top-language-switcher' : ''}`}>
                            {langWithEnglish.map((item) => <ButtonLanguage image={item.flag} key={item.short_name} handleClick={changeLanguage} lang={item.short_name} fullLang={item.name} />)}
                        </LanguageSwitcherDropDownProfile>
                    )
                }
            </ContainerProfile>
        )
    );
};
